import type { ListParams } from '@/shared/types';

export const districtKeys = {
  all: ['districts'] as const,
  list: (params: ListParams) => ['districts', 'list', params] as const,
  detail: (id: string | number) => ['districts', 'detail', id] as const,
  countries: ['districts', 'countries'] as const,
  regionsByCountry: (countryId: number) => ['districts', 'regions', countryId] as const,
  citiesByRegion: (regionId: number) => ['districts', 'cities', regionId] as const,
};
